import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import * as xlsx from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-node-details',
  templateUrl: './node-details.component.html',
  styles: []
})
export class NodeDetailsComponent implements OnChanges {

  @Input() nodes: any[];
  @Input() selectedIntegrationCode: string;
  @Input() selectedDeviceUuid: string;
  @Input() loadingNodes: boolean;
  @Input() selectedDeviceSerialNumber: string;
  @Input() visible: boolean;

  @Output() visibleChange = new EventEmitter<boolean>();

  public rows = 10;
  public first = 0;
  public childNodes: any[] = [];
  public totalNodes = 0;

  constructor(private router: Router) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if( !!changes.nodes?.currentValue || !!changes.selectedIntegrationCode?.currentValue ) {
      if( !this.nodes || !this.selectedIntegrationCode ) { return; }
      this.childNodes = Object.values(this.nodes).filter(node => node.toNodeId === this.selectedIntegrationCode);
      this.totalNodes = this.childNodes.length;
    }
  }

  public navigateToDeviceDetails(deviceUuid?: string): void {
    if( !this.selectedDeviceUuid && !deviceUuid ) { return; }
    const url: string = this.router.serializeUrl(
      this.router.createUrlTree([`/devices/${ !deviceUuid ? this.selectedDeviceUuid : deviceUuid }/details`],
        { queryParams: { showView: 'nettopo' } }));
    window.open(url, '_blank');
  }

  public exportCommunicationsToExcel(): void {
    const worksheet = xlsx.utils.json_to_sheet(this.childNodes);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, `${ this.selectedIntegrationCode }-nettopo-comunications` + EXCEL_EXTENSION);
  }

}
